const FancyOvertone = [
    "BLUE",
    "BLUISH",
    "BROWN",
    "BROWNISH",
    "BROWNISH GREENISH",
    "BROWNISH YELLOWISH",
    "DEEP",
    "GRAY",
    "GRAYISH",
    "GRAYISH GREENISH",
    "GRAYISH YELLOWISH",
    "GREEN",
    "GREENISH",
    "GREY",
    "GREYISH",
    "GREYISH GREENISH",
    "INTENSE",
    "LIGHT",
    "ORANGE",
    "ORANGEY",
    "ORANGY",
    "ORANGY YELLOW",
    "PINKISH",
    "PURPLE",
    "PURPLISH",
    "REDDISH",
    "VIVID",
    "YELLOW",
    "YELLOWISH",
    "YELLOWISH BROWN"
];

export default FancyOvertone;

